import * as tslib_1 from "tslib";
import { renderer } from "@cloudpivot/form";
import { organizationApi } from "@cloudpivot/api";
import { userApi } from "@cloudpivot/api";
export class DefaultUserService {
    getCurrentUser() {
        const json = sessionStorage.getItem("user");
        if (json) {
            const user = JSON.parse(json);
            user.type = renderer.OrganizationType.User;
            user.departments = [
                {
                    id: user.departmentId,
                    name: user.departmentName,
                    type: renderer.OrganizationType.Department,
                    leaf: false,
                    employees: 0
                }
            ];
            return user;
        }
        return null;
    }
    getCurrentUserDept() {
        const user = this.getCurrentUser();
        if (!user || user.departments.length === 0) {
            return null;
        }
        return user.departments[0];
    }
    getDepartmentsBy(deptIds, filterType, sourceType, corpId, excludeCorpId, selectUserIds, workflowInstanceId, activityCode, formRootDeptIds, queryType) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield organizationApi.getOrgTree(deptIds, filterType, sourceType, corpId, excludeCorpId, selectUserIds, workflowInstanceId, activityCode, formRootDeptIds);
            const data = res.data;
            const map = (d) => {
                if (!d)
                    return {};
                d.type = renderer.OrganizationType.Department;
                return d;
            };
            const departments = data.departmentList.filter((item) => !!item).map(map);
            let myDepartment;
            if (data.myDepartment) {
                myDepartment = data.myDepartment.filter((item) => !!item).map(map);
            }
            return {
                departments,
                myDepartment
            };
        });
    }
    getUsersBy(deptId, roleId, filterType, sourceType, workflowInstanceId, activityCode, formRootDeptIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield organizationApi.getUsersTree(deptId, roleId, filterType, sourceType, workflowInstanceId, activityCode, formRootDeptIds);
            const data = res.data;
            const map = (d) => {
                d.type = renderer.OrganizationType.User;
                if (Array.isArray(d.departments)) {
                    d.parentId = d.departments.filter((f) => f && f.id).map((m) => m.id);
                }
                return d;
            };
            const users = data.map(map);
            return users;
        });
    }
    search(name, queryType, deptIds, roleIds, filterType, sourceType, corpId, excludeCorpId, workflowInstanceId, activityCode, formRootDeptIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield organizationApi.search(name, queryType, deptIds, roleIds, filterType, sourceType, corpId, excludeCorpId, workflowInstanceId, activityCode, formRootDeptIds);
            const data = res.data;
            let departments;
            let users;
            let departmentsTotal = data.departmentsTotal;
            let usersTotal = data.usersTotal;
            if (data.departments) {
                departments = data.departments
                    .filter((item) => !!item)
                    .map((d) => {
                    d.type = renderer.OrganizationType.Department;
                    return d;
                });
            }
            if (data.users) {
                users = data.users.map((u) => {
                    u.type = renderer.OrganizationType.User;
                    if (Array.isArray(u.departments)) {
                        u.parentId = u.departments.filter((d) => d && d.id).map((d) => d.id);
                    }
                    return u;
                });
            }
            return {
                departments,
                users,
                departmentsTotal,
                usersTotal
            };
        });
    }
    getUserDepartments(userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield userApi.getUserDepartments(userId);
            if (res.errcode !== 0 || !res.data) {
                return null;
            }
            return res.data.map((d) => ({
                id: d.deptId,
                name: d.deptName
            }));
        });
    }
    getOrganizationLevel(userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield userApi.getOrganizationLevel(userId);
            if (res.errcode !== 0 || !res.data) {
                return null;
            }
            return res.data;
        });
    }
    getDeptLeader(userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield userApi.getDeptLeader(userId);
            if (res.errcode !== 0 || !res.data) {
                return null;
            }
            return res.data;
        });
    }
}
